import styled, { keyframes } from "styled-components";

const marquee = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

export const Bar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: ${({ theme }) => theme.accent};
  overflow: hidden;
  white-space: nowrap;
  z-index: 1001;
`;

export const Track = styled.div`
  display: inline-flex;
  animation: ${marquee} ${({ $duration }) => $duration || 40}s linear infinite;
`;

export const Item = styled.span`
  display: inline-block;
  padding: 6px 48px;
  font-family: ${({ theme }) => theme.mono};
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #000;
`;
